import Card from '@raydiant/raydial/components/Card';
import Text from '@raydiant/raydial/components/Text';
import CreateContentImage from './images/create-content.svg';
import BuildPlaylistImage from './images/build-playlist.svg';
import CreateLocationsImage from './images/create-locations.svg';
import { useHistory } from 'react-router-dom';
import { createNewId } from '../../utilities/identifiers';
import * as paths from '../../routes/paths';
import { useCallback, useMemo } from 'react';
import QuickStartGuideItem from './QuickStartGuideItem';
import analytics from '../../clients/analyticsClient';

const QuickStartGuide = () => {
  const history = useHistory();

  const onNewPlaylist = useCallback(() => {
    analytics.trackQuickStartGuideItemClicked({
      buttonName: 'Go to Playlist builder',
    });
    analytics.trackPlaylistBuilderCTAClicked({
      page: 'getting_started',
      buttonLocation: 'quick_start_guide',
    });
    history.push(
      paths.newPlaylist({
        playlistId: createNewId(),
        folderId: '',
        backTo: paths.gettingStarted(),
        backToLabel: 'Back to Library',
        saveTo: paths.library(),
      }),
    );
  }, [history]);

  const onGoToLibrary = useCallback(() => {
    analytics.trackQuickStartGuideItemClicked({ buttonName: 'Go to Library' });
    analytics.trackGoToLibraryCTAClicked({
      page: 'getting_started',
      buttonLocation: 'quick_start_guide',
    });
    history.push(paths.library());
  }, [history]);

  const onGoToScreens = useCallback(() => {
    analytics.trackQuickStartGuideItemClicked({ buttonName: 'Go to Screens' });
    analytics.trackScreensPageCTAClicked({
      page: 'getting_started',
      buttonLocation: 'quick_start_guide',
    });
    history.push(paths.screens());
  }, [history]);

  const QUICK_START_GUIDE_ITEMS = useMemo(
    () => [
      {
        title: 'Create content',
        description: 'Use 50+ apps to create content ready to display',
        buttonLabel: 'Go to Library',
        onClick: onGoToLibrary,
        imgSrc: CreateContentImage,
      },
      {
        title: 'Build a playlist',
        description: 'Combine your content into playlists to publish',
        buttonLabel: 'Go to Playlist builder',
        onClick: onNewPlaylist,
        imgSrc: BuildPlaylistImage,
      },
      {
        title: 'Create locations & add screens',
        description: 'Organize everything with locations and add screens',
        buttonLabel: 'Go to Screens',
        onClick: onGoToScreens,
        imgSrc: CreateLocationsImage,
      },
    ],
    [onGoToLibrary, onNewPlaylist, onGoToScreens],
  );

  return (
    <Card className="flex flex-col flex-1 w-full xl:min-w-[381px] xl:max-w-[556px] px-6 pt-8 pb-6">
      <div className="flex flex-col gap-1 pl-3 mb-4">
        <Text className="text-black" variant="subheader">
          Quick Start Guide
        </Text>
        <Text className="font-normal" variant="smallSubtitle">
          Explore what Displai has to offer
        </Text>
      </div>
      <div className="flex flex-col gap-4">
        {QUICK_START_GUIDE_ITEMS.map((item) => (
          <QuickStartGuideItem key={item.title} {...item} />
        ))}
      </div>
    </Card>
  );
};

export default QuickStartGuide;
